<div class="flex flex-col" *ngIf="sessionResources.session.value()">
  <div class="flex flex-row mt-2  ">
    <p class="font-theme-source w-full text-sm 2xs:text-base md:text-lg">{{sessionResources.session.value().shortDescription}}, <strong>{{sessionResources.session.value().cityName}}</strong></p>
    <p class="font-theme-source w-full text-right text-sm 2xs:text-base md:text-lg font-bold">{{sessionResources.session.value().date | showEventDate}} à {{sessionResources.session.value().date | showFreeDate: 'HH:mm'}}</p>
  </div>

  <div class="w-full flex flex-col border-t-1 pt-1" *ngIf="subscriptionContextV2Service.defaultOffer() && router?.url?.endsWith('/finalize')">
    <p class="font-theme-source text-sm mt-3" >
      <span>
        <span *ngFor="let item of subscriptionContextV2Service.defaultOffer().formItems">
          <i class="fa-solid fa-check text-theme-green-110 mr-2 mt-2"></i> <span [innerHTML]="item"></span><br/>
        </span>
      </span>
    </p>
  </div>
  <div class="w-full flex flex-col border-t-1 pt-1" *ngIf="subscriptionContextV2Service.defaultOffer() && !router?.url?.endsWith('/finalize')">
    <p class="font-theme-source text-sm mt-0" >
      <span>
        <i class="fa-solid fa-check text-theme-green-110 mr-2 mt-2"></i>A partir de <span class="font-bold">10,90€</span> · <span class="font-bold">Parité H/F</span> · <span class="font-bold">{{sessionResources.session.value()?.capacity}}</span> participants.<br/>
        <i class="fa-solid fa-check text-theme-green-110 mr-2 mt-2"></i>Matchs <span class="font-bold">illimités</span> · <span class="font-bold">7 rencontres</span> garanties.<br/>
      </span>
    </p>
  </div>
</div>
